import { useEffect } from 'react';

import { useRestriction } from '@mssgme/hooks';

export default function Restriction({ rule, subject, children }) {
    const { showWarning } = useRestriction(rule, subject);

    useEffect(() => {
        showWarning();
    }, []);

    return children || null;
}
